<template>

  <!-- UI -->
  <nav class="custom-nav top-card hide-on-small-only"></nav>

  <nav class="nav-extended top-card hide-on-small-only">
    <div class="nav-wrapper container">
      <a href="#!" class="brand-logo" @click.prevent="handleActive(home)">{{ home?.name }}</a>
      <ul class="right hide-on-med-and-down">
        <li v-for="tab in tabs" :key="tab.id" :class="{ 'active blue-grey darken-2': tab.id == currTab.id }"><a href="#"
            @click.prevent="handleActive(tab)">{{ tab.title
            }}</a>
        </li>
      </ul>
    </div>
    <div class="nav-content container">
      <br />
    </div>
  </nav>

    <!-- Mobile only -->
  <nav class="top-card hide-on-large-only">
      <ul class="tabs tabs-transparent">
        <li v-for="tab in tabs" :key="tab.id" class="tab" :class="{ 'active': tab.id == currTab.id }">
          <a href="#" @click.prevent="handleActive(tab)" v-if="shorts">{{ tab?.title?.split(" ")[0] }}</a>
          <a href="#" @click.prevent="handleActive(tab)" v-else>{{ tab.title }}</a>
        </li>
      </ul>
  </nav>

  <!-- search layer -->
  <!-- <div class="grey lighten-4">
    <div class="container section"></div>
  </div> -->

   <!-- breadcrumbs -->
  <nav class="grey lighten-4 z-depth-0">
    <div class="container nav-wrapper">
      <div class="col s12">
        <router-link to="/" class="breadcrumb teal-text"><small> <i class="material-icons left">home</i> Dashboard</small></router-link>
        <span class="breadcrumb blue-grey-text pointable"><small>Invoices Home</small></span>
      </div>
    </div>
  </nav>

  <!-- View Marker -->
  <div id="view"></div>


  <div class="container">

    <div class="section">
      <br />
    <!-- Payment -->
    <PaymentDiv cat="all" :clientId="clientId" />
    </div>
    
  </div>
</template>


<script>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import PaymentDiv from "@/components/client/PaymentClientComponent.vue";


export default {
  name: "invoiceHome",
  components: { PaymentDiv },
  setup() {

    const home = ref(null);
    const currTab = ref(null);
    const tabs = ref([]);

    // vue router
    const router = useRouter();

    // store
    const store = useStore();

    // client ID
    const clientId = store.state?.user?.account?.id;

    // start
    onMounted(() => {
      // page name
      document.title = "Invoices";
    });

    // menu
    onMounted(() => {
      // load tab
      tabs.value.push({ id: 1, name: "Invoices", title: "Home", icon: null, url: "invoices", hash: null, });

      // set default
      currTab.value = tabs.value.find(x => x.title.includes("Home"));
      // set home
      home.value = tabs.value.find(x => x.title.includes("Home"));
    });

    // handle curr status
    const handleActive = (tab) => {
      // refer
      if (tab.hash) {
        router.push({ name: tab.url, hash: tab.hash });
      } else {
        router.push({ name: tab.url });
      }
    };


    return {
      handleActive,
      home,
      currTab,
      tabs,
      clientId
    };
  },
};
</script>

<style scoped>
.top-card {
  background-color: #163f53;
}

.top-card-light {
  background-color: #254657;
}

.top-card-dark {
  background-color: #163f53;
}

.progress {
  margin-top: -10px;
}

.custom-nav {
  height: 15px;
}

/* .nav-extended .nav-wrapper {
  padding: 0 20px;
} */

.brand-logo {
  font-weight: 300;
  font-size: 1.5rem;
}

.nav-wrapper ul li a {
  font-weight: 400;
  padding: 0 15px;
}

.nav-content {
  min-height: 20px;
}
</style>
